import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import InputField from "../../components/form/InputField";
import { getDate, getTodayDate } from "../../util";
import NumberInputField from "../../components/form/NumberInputField";
import TextAreaField from "../../components/form/TextAreaField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import SelectField from "../../components/form/SelectField";
const JournalBatchEntry = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
    } catch (error) {}
  };
  return (
    <MainContainer className="bg-content border border-bkg2">
      <h3 className="p-3">Journal Batch </h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col sm:px-10 "
      >
        <div className="flex">
          <InputField
            register={register}
            name="batch_entry_number"
            label="Batch Entry Number"
            errors={errors.batch_entry_number}
            type="text"
          />
          <div className="flex-1"></div>
        </div>
        <div className="flex">
          <InputField
            register={register}
            name="date"
            label="Date"
            type="Date"
            defaultValue={getTodayDate()}
            errors={errors.date}
          />
          <div className="flex-1"></div>
        </div>
        <TextAreaField
          register={register}
          name="description"
          label="Batch Description"
          errors={errors.description}
        />
        <div className="p-5 text-center">Account Details</div>
        <div className=""></div>

        <div>Total Debit:4000.00</div>
        <div>Total Credit:4000.00</div>
        <div className="p-5 text-center">Approval Status</div>
        <SelectField
          register={register}
          name="status"
          label="Status"
          data={[
            { id: "", name: "-- Select Status" },
            { id: "", name: "Pending" },
            { id: "", name: "Approved" },
            { id: "", name: "Rejected" },
          ]}
          errors={errors.status}
        />
        <TextAreaField
          register={register}
          name="comments"
          label="Comments"
          errors={errors.comments}
        />
        <ResourseButtons link to="/accounts/transaction" />
      </form>
    </MainContainer>
  );
};

export default JournalBatchEntry;
